// @flow
const name = '@wh/sb-login-integration';

export const MESSAGE_PUB_USER_NOT_LOGGED_IN = `${name}/MESSAGE_PUB_USER_NOT_LOGGED_IN`;
export const MESSAGE_PUB_USER_LOGGED_IN = `${name}/MESSAGE_PUB_USER_LOGGED_IN`;
export const MESSAGE_PUB_DISPLAY_REGISTRATION_FORM = `${name}/MESSAGE_PUB_DISPLAY_REGISTRATION_FORM`;

export const MESSAGE_SUB_INIT_CUST = `${name}/MESSAGE_SUB_INIT_CUST`;
export const MESSAGE_SUB_LOGIN_BUTTON_CLICKED = `${name}/MESSAGE_SUB_LOGIN_BUTTON_CLICKED`;

export const MODAL_ACCOUNT_RECOVERY = `${name}/MODAL_ACCOUNT_RECOVERY`;



// WEBPACK FOOTER //
// ./src/main/constants.js